"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMotion = require("react-motion");
var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));
var _reactMultiRef = _interopRequireDefault(require("react-multi-ref"));
var _DragHandle = _interopRequireDefault(require("./DragHandle"));
var _OnUpdate = _interopRequireDefault(require("./OnUpdate"));
var _MoveContainer = _interopRequireDefault(require("./MoveContainer"));

/* eslint react/prop-types: "error" */
var DEFAULT_HEIGHT = {
  natural: 200,
  drag: 30
};
function getScrollSpeed(distance, speed, size) {
  // If distance is zero, then the result is the max speed. Otherwise,
  // the result tapers toward zero as it gets closer to the opposite
  // edge of the region.
  return Math.round(speed - speed / size * distance);
}
var DraggableList = /*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(DraggableList, _React$Component);
  function DraggableList(props) {
    var _this;
    (0, _classCallCheck2.default)(this, DraggableList);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DraggableList).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_itemRefs", new _reactMultiRef.default());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_heights", new Map());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_autoScrollerTimer", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_listEl", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_listElSetter", function (el) {
      if (el) _this._listEl = el;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_handleTouchMove", function (e) {
      e.preventDefault();
      _this._handleMouseMove(e.touches[0]);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_handleMouseMove", function (_ref) {
      var pageY = _ref.pageY,
        clientY = _ref.clientY;
      var _this$props = _this.props,
        padding = _this$props.padding,
        autoScrollMaxSpeed = _this$props.autoScrollMaxSpeed,
        autoScrollRegionSize = _this$props.autoScrollRegionSize;
      var _this$state = _this.state,
        list = _this$state.list,
        dragging = _this$state.dragging,
        lastDrag = _this$state.lastDrag;
      if (!dragging || !lastDrag) return;
      var containerEl = _this._getContainer();
      var dragIndex = _this._getDragIndex();
      var naturalPosition = _this._getDistanceDuringDrag(lastDrag, dragIndex);
      clearInterval(_this._autoScrollerTimer); // If the user has the mouse near the top or bottom of the container and
      // not at the end of the list, then autoscroll.

      if (dragIndex !== 0 && dragIndex !== list.length - 1) {
        var scrollSpeed = 0;
        var containerRect = containerEl && containerEl !== document.body && containerEl.getBoundingClientRect ? containerEl.getBoundingClientRect() : {
          top: 0,
          bottom: Infinity
        }; // Get the lowest of the screen top and the container top.

        var top = Math.max(0, containerRect.top);
        var distanceFromTop = clientY - top;
        if (distanceFromTop > 0 && distanceFromTop < autoScrollRegionSize) {
          scrollSpeed = -1 * getScrollSpeed(distanceFromTop, autoScrollMaxSpeed, autoScrollRegionSize);
        } else {
          // Get the lowest of the screen bottom and the container bottom.
          var bottom = Math.min(window.innerHeight, containerRect.bottom);
          var distanceFromBottom = bottom - clientY;
          if (distanceFromBottom > 0 && distanceFromBottom < autoScrollRegionSize) {
            scrollSpeed = getScrollSpeed(distanceFromBottom, autoScrollMaxSpeed, autoScrollRegionSize);
          }
        }
        if (scrollSpeed !== 0) {
          _this._scrollContainer(scrollSpeed);
          _this._autoScrollerTimer = setTimeout(function () {
            _this._handleMouseMove({
              pageY: pageY + (containerEl === document.body ? scrollSpeed : 0),
              clientY: clientY
            });
          }, 16);
        }
      }
      var containerScroll = !containerEl || containerEl === document.body ? 0 : containerEl.scrollTop;
      var mouseY = pageY - lastDrag.mouseOffset + containerScroll;
      if (_this.props.constrainDrag) {
        mouseY = Math.max(mouseY, _this._getDistanceDuringDrag(lastDrag, 0));
        mouseY = Math.min(mouseY, _this._getDistanceDuringDrag(lastDrag, _this.props.list.length - 1));
      }
      var movementFromNatural = mouseY - naturalPosition; // 1 down, -1 up, 0 neither

      var direction = movementFromNatural > 0 ? 1 : movementFromNatural < 0 ? -1 : 0;
      var newIndex = dragIndex;
      if (direction !== 0) {
        var keyFn = _this._getKeyFn();
        var reach = Math.abs(movementFromNatural);
        for (var i = dragIndex + direction; i < list.length && i >= 0; i += direction) {
          var iDragHeight = (_this._heights.get(keyFn(list[i])) || DEFAULT_HEIGHT).drag;
          if (reach < iDragHeight / 2 + padding) break;
          reach -= iDragHeight + padding;
          newIndex = i;
        }
      }
      var newList = list;
      if (newIndex !== dragIndex) {
        newList = (0, _immutabilityHelper.default)(list, {
          $splice: [[dragIndex, 1], [newIndex, 0, list[dragIndex]]]
        });
      }
      _this.setState({
        lastDrag: (0, _objectSpread2.default)({}, lastDrag, {
          mouseY: mouseY
        }),
        list: newList
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_handleMouseUp", function () {
      clearInterval(_this._autoScrollerTimer);
      window.removeEventListener('mouseup', _this._handleMouseUp);
      window.removeEventListener('touchend', _this._handleMouseUp);
      window.removeEventListener('touchmove', _this._handleTouchMove);
      window.removeEventListener('mousemove', _this._handleMouseMove);
      if (document.documentElement) document.documentElement.style.cursor = '';
      _this._lastScrollDelta = 0;
      var onMoveEnd = _this.props.onMoveEnd;
      var _this$state2 = _this.state,
        dragging = _this$state2.dragging,
        lastDrag = _this$state2.lastDrag,
        list = _this$state2.list;
      if (dragging && lastDrag && onMoveEnd) {
        var dragIndex = _this._getDragIndex();
        if (lastDrag.startIndex !== dragIndex) {
          onMoveEnd(list, list[dragIndex], lastDrag.startIndex, dragIndex);
        }
      }
      _this.setState({
        dragging: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_lastScrollDelta", 0);
    _this.state = {
      list: props.list,
      useAbsolutePositioning: false,
      dragging: false,
      lastDrag: null
    };
    return _this;
  }
  (0, _createClass2.default)(DraggableList, [{
    key: "getItemInstance",
    value: function getItemInstance(key) {
      var ref = this._itemRefs.map.get(key);
      if (!ref) throw new Error('key not found');
      return ref.getTemplate();
    } // TODO this React method is deprecated. Investigate and replace with componentDidUpdate.
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this$state3 = this.state,
        dragging = _this$state3.dragging,
        lastDrag = _this$state3.lastDrag;
      var list = newProps.list;
      check: if (lastDrag) {
        var newDragIndex;
        try {
          newDragIndex = this._getDragIndex(list);
        } catch (err) {
          dragging = false;
          lastDrag = null;
          break check;
        }
        if (dragging) {
          var currentDragIndex = this._getDragIndex();
          if (currentDragIndex !== newDragIndex) {
            // Let's change the list so that the new drag index will be the same as
            // the current so that the dragged item doesn't jump on the screen.
            list = (0, _immutabilityHelper.default)(list, {
              $splice: [[newDragIndex, 1], [currentDragIndex, 0, list[newDragIndex]]]
            });
          }
        }
      }
      this.setState({
        dragging: dragging,
        lastDrag: lastDrag,
        list: list
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._handleMouseUp();
    }
  }, {
    key: "_handleTouchStart",
    value: function _handleTouchStart(itemKey, pressY, event) {
      event.stopPropagation();
      this._handleStartDrag(itemKey, pressY, event.touches[0].pageY);
    }
  }, {
    key: "_handleMouseDown",
    value: function _handleMouseDown(itemKey, pressY, event) {
      event.preventDefault();
      this._handleStartDrag(itemKey, pressY, event.pageY);
    }
  }, {
    key: "_handleStartDrag",
    value: function _handleStartDrag(itemKey, pressY, pageY) {
      var _this2 = this;
      if (document.documentElement) document.documentElement.style.cursor = 'move';
      window.addEventListener('mouseup', this._handleMouseUp);
      window.addEventListener('touchend', this._handleMouseUp);
      window.addEventListener('touchmove', this._handleTouchMove);
      window.addEventListener('mousemove', this._handleMouseMove); // If an element has focus while we drag around the parent, some browsers
      // try to scroll the parent element to keep the focused element in view.
      // Stop that.

      {
        var listEl = this._listEl;
        if (!listEl) throw new Error('Should not happen');
        if (listEl.contains && document.activeElement && listEl.contains(document.activeElement)) {
          document.activeElement.blur();
        }
      }
      var keyFn = this._getKeyFn();
      if (this._heights.size === 0) {
        this._heights = new Map(this.state.list.map(function (item) {
          var key = keyFn(item);
          var containerRef = _this2._itemRefs.map.get(key);
          var refEl = containerRef ? containerRef.getDOMNode().firstElementChild : null;
          var ref = containerRef ? containerRef.getTemplate() : null;
          var natural = refEl instanceof HTMLElement ? refEl.offsetHeight : DEFAULT_HEIGHT.natural;
          var drag = ref && typeof ref.getDragHeight === 'function' && ref.getDragHeight() || natural;
          return [key, {
            natural: natural,
            drag: drag
          }];
        }));
      }
      var itemIndex = this.state.list.map(keyFn).indexOf(itemKey);
      var startY = pressY == null ? this._getDistance(0, itemIndex, false) : pressY;
      var containerEl = this._getContainer();
      var containerScroll = !containerEl || containerEl === document.body ? 0 : containerEl.scrollTop; // Need to re-render once before we start dragging so that the `y` values
      // are set using the correct _heights and then can animate from there.

      this.forceUpdate(function () {
        _this2.setState({
          useAbsolutePositioning: true,
          dragging: true,
          lastDrag: {
            itemKey: itemKey,
            startIndex: itemIndex,
            startListKeys: _this2.state.list.map(keyFn),
            startY: startY,
            mouseY: startY,
            mouseOffset: pageY - startY + containerScroll
          }
        });
      });
    }
  }, {
    key: "_scrollContainer",
    value: function _scrollContainer(delta) {
      var containerEl = this._getContainer();
      if (!containerEl) return;
      if (window.scrollBy && containerEl === document.body) {
        window.scrollBy(0, delta);
      } else {
        containerEl.scrollTop += delta;
      }
    }
  }, {
    key: "_adjustScrollAtEnd",
    value: function _adjustScrollAtEnd(delta) {
      var frameDelta = Math.round(delta - this._lastScrollDelta);
      this._scrollContainer(frameDelta);
      this._lastScrollDelta += frameDelta;
    }
  }, {
    key: "_getDragIndex",
    value: function _getDragIndex(list, lastDrag) {
      if (!list) list = this.state.list;
      if (!lastDrag) lastDrag = this.state.lastDrag;
      if (!lastDrag) {
        throw new Error('No drag happened');
      }
      var keyFn = this._getKeyFn();
      var _lastDrag = lastDrag,
        itemKey = _lastDrag.itemKey;
      for (var i = 0, len = list.length; i < len; i++) {
        if (keyFn(list[i]) === itemKey) {
          return i;
        }
      }
      throw new Error('Failed to find drag index');
    }
  }, {
    key: "_getDistance",
    value: function _getDistance(start, end, dragging) {
      if (end < start) {
        return -this._getDistance(end, start, dragging);
      }
      var padding = this.props.padding;
      var list = this.state.list;
      var keyFn = this._getKeyFn();
      var distance = 0;
      for (var i = start; i < end; i++) {
        var height = this._heights.get(keyFn(list[i])) || DEFAULT_HEIGHT;
        distance += (dragging ? height.drag : height.natural) + padding;
      }
      return distance;
    }
  }, {
    key: "_getDistanceDuringDrag",
    value: function _getDistanceDuringDrag(lastDrag, index) {
      var keyFn = this._getKeyFn();
      var list = this.state.list;
      var offset = 0;
      if (this._getDragIndex() < lastDrag.startIndex) {
        var dragItemHeight = this._heights.get(lastDrag.itemKey) || DEFAULT_HEIGHT;
        var newCenterHeight = this._heights.get(keyFn(list[lastDrag.startIndex])) || DEFAULT_HEIGHT;
        offset = dragItemHeight.drag - newCenterHeight.drag;
      }
      return lastDrag.startY + offset + this._getDistance(lastDrag.startIndex, index, true);
    }
  }, {
    key: "_getContainer",
    value: function _getContainer() {
      var container = this.props.container;
      return container ? container() : null;
    }
  }, {
    key: "_getKeyFn",
    value: function _getKeyFn() {
      var itemKey = this.props.itemKey;
      return typeof itemKey === 'function' ? itemKey : function (x) {
        return x[itemKey];
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        springConfig = _this$props2.springConfig,
        container = _this$props2.container,
        padding = _this$props2.padding,
        template = _this$props2.template,
        unsetZIndex = _this$props2.unsetZIndex,
        commonProps = _this$props2.commonProps;
      var _this$state4 = this.state,
        list = _this$state4.list,
        dragging = _this$state4.dragging,
        lastDrag = _this$state4.lastDrag,
        useAbsolutePositioning = _this$state4.useAbsolutePositioning;
      var keyFn = this._getKeyFn();
      var anySelected = (0, _reactMotion.spring)(dragging ? 1 : 0, springConfig);
      var children = list.map(function (item, i) {
        var key = keyFn(item);
        var selectedStyle = dragging && lastDrag && lastDrag.itemKey === key ? {
          itemSelected: (0, _reactMotion.spring)(1, springConfig),
          y: lastDrag.mouseY
        } : {
          itemSelected: (0, _reactMotion.spring)(0, springConfig),
          y: (useAbsolutePositioning ? _reactMotion.spring : function (x, ignored) {
            return x;
          })(dragging && lastDrag ? _this3._getDistanceDuringDrag(lastDrag, i) : _this3._getDistance(0, i, false), springConfig)
        };
        var style = (0, _objectSpread2.default)({
          anySelected: anySelected
        }, selectedStyle);
        var makeDragHandle = function makeDragHandle(el, getY) {
          return React.createElement(_DragHandle.default, {
            onMouseDown: function onMouseDown(e) {
              return _this3._handleMouseDown(key, getY(), e);
            },
            onTouchStart: function onTouchStart(e) {
              return _this3._handleTouchStart(key, getY(), e);
            }
          }, el);
        };
        var height = _this3._heights.get(key) || DEFAULT_HEIGHT;
        return React.createElement(_reactMotion.Motion, {
          style: style,
          key: key,
          children: function children(_ref2) {
            var itemSelected = _ref2.itemSelected,
              anySelected = _ref2.anySelected,
              y = _ref2.y;
            return React.createElement(_MoveContainer.default, {
              ref: _this3._itemRefs.ref(key),
              y: useAbsolutePositioning ? y : null,
              template: template,
              padding: padding,
              item: item,
              itemSelected: itemSelected,
              anySelected: anySelected,
              height: height,
              zIndex: unsetZIndex && !useAbsolutePositioning ? 'auto' : lastDrag && lastDrag.itemKey === key ? list.length : i,
              makeDragHandle: makeDragHandle,
              commonProps: commonProps
            });
          }
        });
      });
      var adjustScroll = 0;
      if (!dragging && lastDrag && useAbsolutePositioning) {
        var dragIndex = this._getDragIndex();
        adjustScroll = (0, _reactMotion.spring)(this._getDistance(0, dragIndex, false) - lastDrag.mouseY, springConfig);
      }
      var fullContainerHeight = "".concat(this._getDistance(0, list.length, false), "px");
      return React.createElement("div", {
        style: {
          position: 'relative'
        },
        ref: this._listElSetter
      }, React.createElement(_reactMotion.Motion, {
        style: {
          adjustScroll: adjustScroll,
          anySelected: anySelected
        },
        onRest: function onRest() {
          if (!dragging) {
            _this3._heights.clear();
            _this3.setState({
              useAbsolutePositioning: false
            });
          }
        },
        children: function children(_ref3) {
          var adjustScroll = _ref3.adjustScroll;
          return React.createElement("div", {
            style: {
              display: useAbsolutePositioning ? 'block' : 'none',
              height: useAbsolutePositioning ? fullContainerHeight : '0px'
            }
          }, container && React.createElement(_OnUpdate.default, {
            cb: function cb() {
              if (!dragging && lastDrag && useAbsolutePositioning) {
                _this3._adjustScrollAtEnd(adjustScroll);
              }
            }
          }));
        }
      }), children);
    }
  }]);
  return DraggableList;
}(React.Component);
exports.default = DraggableList;
(0, _defineProperty2.default)(DraggableList, "propTypes", {
  itemKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]).isRequired,
  template: _propTypes.default.func,
  list: _propTypes.default.array.isRequired,
  onMoveEnd: _propTypes.default.func,
  container: _propTypes.default.func,
  springConfig: _propTypes.default.object,
  constrainDrag: _propTypes.default.bool,
  padding: _propTypes.default.number,
  unsetZIndex: _propTypes.default.bool,
  autoScrollMaxSpeed: _propTypes.default.number.isRequired,
  autoScrollRegionSize: _propTypes.default.number.isRequired,
  commonProps: _propTypes.default.object
});
(0, _defineProperty2.default)(DraggableList, "defaultProps", {
  springConfig: {
    stiffness: 300,
    damping: 50
  },
  padding: 10,
  unsetZIndex: false,
  constrainDrag: false,
  autoScrollMaxSpeed: 15,
  autoScrollRegionSize: 30
});
module.exports = exports.default;
module.exports.default = exports.default;